import Layout from '@/views/zy/layout'
export default [
  {
    path: '/zy',
    component: Layout,
    redirect: '/zy/index',
    name: 'Zy',
    meta: { title: '高考直通车-志愿卡特权'},
    children: [
      {
        path: 'index',
        name: 'Index',
        component: () => import('@/views/zy/index'),
        meta: { title: '高考直通车-志愿卡特权' },
      },
      {
        path: 'product',
        name: 'Product',
        component: () => import('@/views/zy/product'),
        meta: { title: '高考直通车-志愿服务' },
      },
      {
        path: 'productChannel',
        name: 'ProductChannel',
        component: () => import('@/views/zy/productChannel'),
        meta: { title: '高考直通车-志愿卡特权' },
      },
      {
        path: 'comment',
        name: 'comment',
        component: () => import('@/views/zy/comment'),
        meta: { title: '志愿卡评价' },
      },
      {
        path: 'productInvited',
        name: 'ProductInvited',
        component: () => import('@/views/zy/productInvited'),
        meta: { title: '高考直通车-志愿卡特权' },
      },
      {
        path: 'payChannel',
        name: 'PayChannel',
        component: () => import('@/views/zy/payChannel'),
        meta: { title: '高考直通车-志愿卡特权' },
      },
      {
        path: 'pay',
        name: 'Pay',
        component: () => import('@/views/zy/pay'),
        meta: { title: '高考直通车-志愿卡特权' },
      },
      {
        path: 'exchange',
        name: 'Exchange',
        component: () => import('@/views/zy/exchange'),
        meta: { title: '高考直通车-志愿卡特权-兑换中心' },
      },
      {
        path: 'paySuccess',
        name: 'PaySuccess',
        component: () => import('@/views/zy/paySuccess'),
        meta: { title: '高考直通车-志愿卡特权-支付成功' },
      },
      {
        path: 'index/:gsrc',
        name: 'Index',
        component: () => import('@/views/zy/index'),
        meta: { title: '高考直通车-志愿卡特权' },
      },
      {
        path: 'product/:gsrc',
        name: 'Product',
        component: () => import('@/views/zy/product'),
        meta: { title: '高考直通车-志愿卡特权' },
      },
      {
        path: 'productChannel/:gsrc',
        name: 'ProductChannel',
        component: () => import('@/views/zy/productChannel'),
        meta: { title: '高考直通车-志愿卡特权' },
      },
      {
        path: 'productInvited/:gsrc',
        name: 'ProductInvited',
        component: () => import('@/views/zy/productInvited'),
        meta: { title: '高考直通车-志愿卡特权' },
      },
      {
        path: 'pay/:gsrc',
        name: 'Pay',
        component: () => import('@/views/zy/pay'),
        meta: { title: '高考直通车-志愿卡特权' },
      },
      {
        path: 'exchange/:gsrc',
        name: 'Exchange',
        component: () => import('@/views/zy/exchange'),
        meta: { title: '高考直通车-志愿卡特权-兑换中心' },
      },
      {
        path: 'paySuccess/:gsrc',
        name: 'PaySuccess',
        component: () => import('@/views/zy/paySuccess'),
        meta: { title: '高考直通车-志愿卡特权-支付成功' },
      },
      {
        path: 'invite/:gsrc',
        name: 'Invite',
        component: () => import('@/views/zy/invite'),
        meta: { title: '高考直通车-志愿卡特权-邀请好友' },
      },
      {
        path: 'ykexchange',
        name: 'ykexchange',
        component: () => import('@/views/zy/ykexchange'),
        meta: { title: '高考直通车-艺考志愿卡特权-兑换中心' },
      },
      {
        path: 'ykexchange/:gsrc',
        name: 'ykexchange',
        component: () => import('@/views/zy/ykexchange'),
        meta: { title: '高考直通车-艺考志愿卡特权-兑换中心' },
      },
      {
        path: 'xkexchange',
        name: 'xkexchange',
        component: () => import('@/views/zy/xkexchange'),
        meta: { title: '兑换春季高考志愿卡' },
      },
      {
        path: 'xkexchange/:gsrc',
        name: 'xkexchange',
        component: () => import('@/views/zy/xkexchange'),
        meta: { title: '兑换春季高考志愿卡' },
      },
      {
        path: 'sjexchange',
        name: 'sjexchange',
        component: () => import('@/views/zy/sjexchange'),
        meta: { title: '高考直通车-双季志愿卡-兑换中心' },
      },
      {
        path: 'sjexchange/:gsrc',
        name: 'sjexchange',
        component: () => import('@/views/zy/sjexchange'),
        meta: { title: '高考直通车-双季志愿卡-兑换中心' },
      },
    ]
  },
  {
    path: '/zy/agreement',
    component: () => import('@/views/zy/agreement'),
    name: 'Agreement',
    meta: { title: '高考直通车-志愿卡服务协议'},
  },
  {
    path: '/zy/invite',
    name: 'Invite',
    component: () => import('@/views/zy/invite'),
    meta: { title: '高考直通车-志愿卡特权-邀请好友' },
  },
  {
    path: '/zy/inviteRecord',
    name: 'InviteRecord',
    component: () => import('@/views/zy/inviteRecord'),
    meta: { title: '高考直通车-志愿卡特权-邀请好友' },
  },
]
